<template>
  <v-layout row wrap justify-center>
    <v-btn
      style="position: absolute; top: -35px; right: 20px;"
      @click="print"
      fab
      dark
      small
      color="primary"
      class="hidden-print-only"
    >
      <v-icon>mdi-printer</v-icon>
    </v-btn>

    <v-flex xs11 class="text-xs-center mt-5">
      <v-layout row wrap>
        <v-flex xs12 class="display-1">Zaitoon Skin & Cosmetic Hospital</v-flex>
        <v-flex xs12>
          <span class="mx-2 headline text-capitalize">{{report.type}} Report</span>
        </v-flex>

        <v-flex xs12 mt-1>
          <span class="mx-2 subheading">{{report.startDate + ' - ' + report.endDate}}</span>
        </v-flex>
      </v-layout>
    </v-flex>

    <!-- table -->
    <v-flex xs12 class="my-4 mx-4">
      <v-data-table :headers="headers" :items="report.data" hide-actions>
        <template slot="items" slot-scope="{item}">
          <td>{{ item.patient_name }}</td>
          <td>{{ item.type | type }}</td>
          <td>{{ item.amount }}</td>
          <td>{{ item.discount }}</td>
          <td>{{ item.date | moment('YYYY-MM-DD') }}</td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  middleware: "admin",
  layout: "print",
  data() {
    return {
      headers: [
        { text: "Patient Name", value: "patient_name", sortable: false },
        { text: "Type", value: "type", sortable: false },
        { text: "Amount (AFN)", value: "amount", sortable: false },
        { text: "Discount (AFN)", value: "discount", sortable: false },
        { text: "Date", value: "date", sortable: false }
      ]
    };
  },
  computed: {
    report() {
      return this.$store.getters["base/reports"];
    }
  },
  methods: {
    print() {
      window.print();
    }
  },
  filters: {
    type: function(value) {
      const map = {
        patient_test: "Lab Test Fee",
        patient_procedure: "Procedure Fee",
        prescriptions: "Prescription Total",
        appointments: "Appointment Fee"
      };

      return map[value];
    }
  }
};
</script>

<style lang="scss" scoped>
</style>